import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
    createConcern,
    deleteConcern,
    concernListFilter,

} from "@/services/concern";

@Module({
    namespaced: true
})

export default class concern extends VuexModule {
     // state
     concernOptionData = [];

    // Action

    @Action
    public async concernCreate(payload) {
        try {
        const data = await createConcern(payload);
        return data;
        } catch (err) {
        throw err;
        }
    }

    @Action
    public async ConcernDeleteAction(payload) {
        try {
        const data = await deleteConcern(payload);
        return data
        } catch (error) {
        throw error
        }
    }

    @Action
    public async concernFilterAction(payload) {
        try {
        const data = await concernListFilter(payload);
        this.context.commit("setConcernList", data.data);
        return data
        } catch (error) {
        throw error
        }
    }

    //Mutations
    @Mutation
    public setConcernList(data: any) {
        this.concernOptionData = data;
    }

    //Getters
    
}